import React, { useEffect, useState, ChangeEvent } from 'react';
import { Checkbox } from '@scholastic/volume-react';
import StepDescription from '../StepDescription/StepDescription';

import { TypeOfReport } from '../ReportSelector/ReportType.data';

import { SITE_SELECTOR_STEP_DESCRIPTIONS } from './SiteSelector.data';
import './SiteSelector.scss';

export type OutputType = 'Html' | 'Csv';

export interface SiteSelectorProps {
  reportType: TypeOfReport;
  defaultOutputType?: OutputType;
  onCheckboxSelection: (value: boolean) => void;
  onReportTypeSelection: (outputType: OutputType) => void;
}

const SiteSelector = ({
  reportType,
  defaultOutputType,
  onCheckboxSelection,
  onReportTypeSelection,
}: SiteSelectorProps) => {
  const stepDescription = SITE_SELECTOR_STEP_DESCRIPTIONS[reportType];

  const casualReportIsSelected =
    reportType === 'OUS' || reportType === 'DDU' || reportType === 'DSU' || reportType === 'OSR';

  const isSummaryReport =
    reportType === 'ISR' ||
    reportType === 'UGR' ||
    reportType === 'SRISR' ||
    reportType === 'DUBG' ||
    reportType === 'SUBG';

  const [combineIndividualSite, setCombineIndividualSite] = useState(true);

  const [reportOutput, setReportOutput] = useState<OutputType>('Html');

  useEffect(() => {
    onCheckboxSelection(combineIndividualSite);
  }, [combineIndividualSite, onCheckboxSelection]);

  useEffect(() => {
    onReportTypeSelection(reportOutput);
  }, [reportOutput, onReportTypeSelection]);

  return (
    <div className="stats-site-selector">
      {!isSummaryReport && (
        <div className="stats-site-selector__section-element">
          <StepDescription order="4" description={stepDescription} />
        </div>
      )}

      {casualReportIsSelected && (
        <div className="stats-site-selector__section-element">
          <div className="stats-site-selector__check-box-holder stats-site-selector__check-box-holder--full">
            <span className="stats-site-selector__check-box-label">
              <Checkbox
                checked={combineIndividualSite}
                onInputChange={(event) => {
                  setCombineIndividualSite((event.currentTarget as HTMLInputElement).checked);
                }}
              />
            </span>
            <span className="stats-site-selector__check-box-label">Include Individual Sites</span>
          </div>
        </div>
      )}

      <div className="stats-site-selector__section-element">
        <StepDescription order={(isSummaryReport && '4') || '5'} description="Select your output" />
      </div>
      <div className="stats-site-selector__checkbox-holder">
        <div className="vol-form__check m-2 p-2">
          <label className="vol-form__check-label">
            <input
              name="outputType"
              type="radio"
              className="mr-2"
              value="Html"
              checked={defaultOutputType === 'Html'}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                setReportOutput(e.target.value as OutputType)
              }
            />
            On-Screen
          </label>
        </div>
        <div className="vol-form__check m-2 p-2">
          <label className="vol-form__check-label">
            <input
              name="outputType"
              type="radio"
              className="mr-2"
              value="Csv"
              checked={defaultOutputType === 'Csv'}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                setReportOutput(e.target.value as OutputType)
              }
            />
            Download
          </label>
        </div>
      </div>
    </div>
  );
};

export default SiteSelector;
